  <template>
  <div >
    <md-dialog style="z-index: 110" :md-active.sync="showDialog" @md-closed="closed()">
      <md-dialog-title class="topmap-title" style="color: rgb(42, 83, 119);
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;">
        <span>
          <md-icon style="color: rgb(42, 83, 119);margin: 0px;">location_on</md-icon>Posição do Cliente
        </span>
        <span>{{endereco}}</span>
      </md-dialog-title>
      <GmapMap
        ref="mapRef"
        :options="mapOptions"
        :center="{lat:latitude, lng:longitude}"
        :zoom="13"
        map-type-id="satellite"
      >
        <GmapMarker
          ref="myMarker"
          @click="center={lat:latitude, lng:longitude}"
          :position="google && new google.maps.LatLng(latitude, longitude)"
          :icon="recIcon"
        />
      </GmapMap>
      <md-dialog-actions style="justify-content: center;">
        <md-button class="md-primary" @click="showDialog = false">Fechar</md-button>
        <md-button class="md-primary" @click="openmap(latitude, longitude)">Compartilhar</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";
export default {
  name: "Map",
  props: {
    endereco: String,
    coords: Object,
    recIcon: {
      type: String,
      path: require("@/assets/img/rec-marker.svg"),
      default: require("@/assets/img/rec-marker.svg")
    }
  },
  computed: {
    google: gmapApi
  },
  data: () => ({
    showDialog: true,
    mapOptions: {
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false
    },
    latitude: null,
    longitude: null
  }),
  mounted() {
    var self = this;
    self.latitude = self.coords.lat;
    self.longitude = self.coords.lng;
    this.$refs.mapRef.$mapPromise.then(map => {
      map.panTo({ lat: self.latitude, lng: self.longitude });
    });
  },
  methods: {
    openmap(lat, lng){
      
      window.open(`https://maps.google.com/?q=${lat},${lng}&hl=pt-BR&gl=br`, '_blank')
    },
    closed() {
      this.$emit("closed", true);
    }
  }
};
</script>
